import { render } from "./ProjectEditContentComponent.vue?vue&type=template&id=03b3b956"
import script from "./ProjectEditContentComponent.vue?vue&type=script&lang=js"
export * from "./ProjectEditContentComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__